<nz-row [nzGutter]="16" class="items-start">
  	<nz-col [nzSpan]="24">
		<nz-page-header nzTitle="Scheduled & Automated Communications"></nz-page-header>
		<div class="table-wrapper">
			<a [routerLink]="['/communication/send']" nz-button nzType="dashed" class="mb-1" >+ Add Communication</a>
			<nz-table *ngIf="bulkPayload" nzSize="default" 
				[nzData]="bulkPayload" 
				[nzFrontPagination]="false"
				[nzBordered]="true"
				[nzLoading]="loading"
				[nzTotal]="total"
				[nzPageSize]="pageSize"
				[nzPageIndex]="pageIndex"
				[nzShowSizeChanger]="true"
				[nzPageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]"
				(nzQueryParams)="onQueryParamsChange($event, getThis())">
				<thead>
					<tr>
						<th nzWidth="40px"></th>
						<th>ID</th>
						<th>Channel</th>
						<th>Subject</th>
						<th>Message</th>
						<th>Trigger</th>
						<th>Next Run Date</th>
						<th>Delivery Report</th>
						<th>Status</th>
						<th>Action</th>
					</tr>
				</thead>
			
				<tbody>
					<ng-template ngFor let-item [ngForOf]="bulkPayload">
						<tr>
							<td nzExpand [(nzExpand)]="item.expanded" (nzExpandChange)="onExpand(item)"></td>
			
							<td>{{item.bulk?.id}}</td>
							<td>{{item.bulk?.channel}}</td>
							<td>{{item.bulk?.subject}}</td>
							<td>{{item.bulk?.body}}</td>
							<td>{{item.trigger?.triggerType}}</td>
							<td>{{item.bulk?.nextRunDate | date:'yyyy-MM-dd HH:mm'}}</td>
							<td>{{item.bulk?.deliveryReport ? 'Yes' : 'No'}}</td>
							<td [ngStyle]="item.bulk?.status !== 'Disabled' ? {'color': '#52c41a'} : {'color': 'red'}">
								{{item.bulk?.status}}
							</td>
							<td>
								<div *ngIf="item.trigger?.triggerType !== 'OnceOff'" class="btn-group" role="group">
									<button nz-button nzType="default"
										nz-tooltip="{{ item.bulk?.status === 'Active' ? 'Disable schedule' : 'Enable schedule' }}"
										(click)="toggleStatus(item).subscribe()">
										<i nz-icon [nzType]="item.bulk?.status === 'Active' ? 'stop' : 'play-circle'"
											nzTheme="outline"></i>
										{{ item.bulk?.status === 'Active' ? 'Disable' : 'Enable' }}
									</button>
									<button nz-button nzType="default" nz-tooltip="Edit schedule" (click)="editSchedule(item)">
										<i nz-icon nzType="edit" nzTheme="outline"></i> Edit
									</button>
								</div>
							</td>
						</tr>
			
						<tr *ngIf="item.expanded">
							<td></td>
							<td colspan="8">
								<div class="row p-3">
									<div class="col-6">
										<app-filter-info [displayType]="'card'" [filters]="item.filters"></app-filter-info>
									</div>
			
									<div class="col-6">
										<app-schedule-info [trigger]="item.trigger"></app-schedule-info>
									</div>
								</div>
							</td>
						</tr>
					</ng-template>
				</tbody>
			</nz-table>
		</div>
	</nz-col>
</nz-row>